import React from 'react';

import Icon from './Icon';

const CancelIcon = (props) => {
    return (
        <Icon width='24' height='24' {...props}>
            <g stroke='#272A33' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <path d='M19.483 4.522 4.526 19.479M4.527 4.522l14.956 14.957' />
            </g>
        </Icon>
    );
};

export default CancelIcon;
